/* ===========================================================================
   AutoFxMart — Velocity Homepage behaviour (shared, deferred).
   Loaded once across the afx-home-* sections (guards against double-init).
   CWV: IntersectionObserver reveal, event DELEGATION (no per-card listeners),
   rAF-batched DOM writes, passive listeners, prefers-reduced-motion honoured.
   =========================================================================== */
(function () {
  if (window.__afxHomeInit) return;
  window.__afxHomeInit = true;

  // flag the document so reveal's hidden state only applies with JS present
  document.documentElement.classList.add('afx-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1 · One-shot scroll reveal ──────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.afx-rv:not(.in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      // batch the class writes into one frame
      var hits = [];
      entries.forEach(function (en) { if (en.isIntersecting) { hits.push(en.target); io.unobserve(en.target); } });
      if (!hits.length) return;
      requestAnimationFrame(function () { hits.forEach(function (el) { el.classList.add('in'); }); });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    // failsafe: never leave anything hidden
    setTimeout(function () { document.querySelectorAll('.afx-rv:not(.in)').forEach(function (el) { el.classList.add('in'); }); }, 2200);
  }

  /* ── 2 · Toast ───────────────────────────────────────────────────────── */
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'afx-toast';
      toastEl.innerHTML = '<i></i><span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('in');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('in'); }, 2200);
  }

  /* ── 3 · Add to cart (delegated, optimistic, AJAX) ───────────────────── */
  function money(cents) {
    try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-afx-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;
    var name = btn.getAttribute('data-name') || 'Item';
    var label = btn.querySelector('[data-afx-add-label]') || btn;
    var original = label.textContent;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        btn.classList.add('is-added');
        label.textContent = 'Added \u2713';
        toast(name + ' \u2014 added to cart');
        // let the host theme's drawer react; fall back to the toast above
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        setTimeout(function () { btn.classList.remove('is-added'); label.textContent = original; btn.disabled = false; }, 1400);
      })
      .catch(function () {
        toast('That didn\u2019t take. Try again.');
        btn.disabled = false;
      });
  }, false);

  /* ── 4 · Smooth-scroll for in-page anchors (hero CTA → department grid) ─ */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-afx-scroll]');
    if (!a) return;
    var sel = a.getAttribute('href');
    if (!sel || sel.charAt(0) !== '#') return;
    var target = document.querySelector(sel);
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }, false);

  /* ── boot ────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReveal);
  else initReveal();
  // re-scan when sections are (re)rendered in the theme editor
  document.addEventListener('shopify:section:load', initReveal);
})();
